import { cloneDeep } from 'lodash';
import { addNodeId } from './nodeIdPool'

/**
 * 录音添加id
 */
export const from2_0to2_1 = (json) => {
  if (json.version !== '2.0') return json;
  const newJson = json
  // 节点上录音添加id
  for (const scene of (newJson?.scenes || [])) {
    for (const node of (scene?.nodes || [])) {
      for (const voice of (node.voices || [])) {
        voice.id = addNodeId('V')
      }
    }
  }

  // 全局解答上录音添加id
  for (const knowl of (newJson?.knowledge || [])) {
    for (const voice of (knowl?.responses || [])) {
      voice.id = addNodeId('V')
    }
  }
  if (newJson?.settings?.general?.timeout_voices?.[0]) {
    newJson.settings.general.timeout_voices[0].id = addNodeId('V')
  }
  newJson.version = '2.1';
  return newJson;
}

/**
 * 2.2 修改了关键词，关键词从字符串改成数组
 */
export const from2_1to2_2 = (json) => {
  if (json.version !== '2.1') return json;
  const newJson = json
  for (const intent of (newJson.intents || [])) {
    intent.sentences = intent.key_words && intent.key_words.split(' ') || [];
    intent.key_words = '';
  }
  for (const knowledge of (newJson.knowledge || [])) {
    knowledge.sentences = knowledge.key_words && knowledge.key_words.split(' ') || [];
    knowledge.key_words = ''
  }
  for (const scene of (newJson.scenes || [])) {
    for (const node of (scene.nodes || [])) {
      if (node.type !== 'collect') continue
      node.collect_confirm_sentences = node.collect_confirm_keywords && node.collect_confirm_keywords.split(' ') || []
      node.collect_refuse_sentences = node.collect_refuse_keywords && node.collect_refuse_keywords.split(' ') || []
      node.collect_confirm_keywords = '' 
      node.collect_refuse_keywords = ''
    }
  }
  newJson.version = '2.2';
  return newJson;
}

const upgradeSceneList = [
  from2_0to2_1,
  from2_1to2_2
]

export const upgradeScene = async(json) => {
  let newJson = cloneDeep(json)
  for await (const upgrade of upgradeSceneList) {
    newJson = upgrade(json)
  }
  return newJson;
}
